import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.AccountUsageOne', {
    title: 'Account usage',
    requiredField: 'Field is required',
    textLengthError: 'The text must be between 15 and 255 characters',
});
